<script setup lang="ts">
import { Search } from 'lucide-vue-next'
import { ComboboxInput } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = defineProps<{
  type?: string
  disabled?: boolean
  autoFocus?: boolean
  asChild?: boolean
  as?: unknown
}>()
</script>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<template>
  <div class="flex items-center border-b px-3" cmdk-input-wrapper>
    <Search class="mr-2 h-4 w-4 shrink-0 opacity-50" />
    <ComboboxInput
      v-bind="{ ...props, ...$attrs }"
      auto-focus
      :class="
        cn(
          'placeholder:text-muted-foreground flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
          $attrs.class ?? ''
        )
      "
    />
  </div>
</template>
